import { useState } from "react"
import { SelectCustomModelNumberModal } from "../SelectCustomModelNumberModal/SelectCustomModelNumberModal"
import type { TCustomModelNumber } from "types/customModelNumbers.type"
import style from "./CustomModelNumberField.module.scss"

const { section, headerRow, titleGroup, title, requiredMark, editLink, tagRow, tag, selectLink } = style

type Props = {
	drawingId: number | null
	value: TCustomModelNumber | null
	onChange: (model: TCustomModelNumber) => void
	/** The panel's currently-typed dimensions — fed to the picker's match badges. */
	dimensions: { width: number | null; height: number | null; depth: number | null }
	/** The quotation's configured series, resolved to its display name — passed straight to the picker. */
	seriesName: string | null
}

/**
 * "Model number" field of the "add custom object" panel (#1371) — the create-flow's own, much
 * smaller sibling of `ModelNumberSection`: a link or a tag, opening `SelectCustomModelNumberModal`
 * instead of the REQ-398 picker. No `useArbitraryEndpoint`/backend call on save — there is no
 * furniture yet, the pick only updates local form state until Create object is pressed, same
 * precedent `CreateFurnitureSidebar`'s `onSelect` already sets for the cabinet flow.
 */
export const CustomModelNumberField = ({ drawingId, value, onChange, dimensions, seriesName }: Props) => {
	const [isOpen, setIsOpen] = useState(false)

	return (
		<div className={section}>
			<div className={headerRow}>
				<div className={titleGroup}>
					<span className={title}>Model number</span>
					<span className={requiredMark}>*</span>
				</div>
				{value ? (
					<button type="button" className={editLink} onClick={() => setIsOpen(true)}>
						Edit
					</button>
				) : null}
			</div>
			{value ? (
				<div className={tagRow}>
					<span className={tag}>{value.model_number}</span>
				</div>
			) : (
				<button type="button" className={selectLink} onClick={() => setIsOpen(true)}>
					Select custom model number
				</button>
			)}
			<SelectCustomModelNumberModal
				isOpen={isOpen}
				onClose={() => setIsOpen(false)}
				drawingId={drawingId}
				dimensions={dimensions}
				seriesName={seriesName}
				initialSelectedId={value?.id ?? null}
				onSave={onChange}
			/>
		</div>
	)
}
